import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { isNull } from 'lodash';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { AuthState } from '~auth/states/auth.state';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard  {
  private authState = inject(AuthState);
  private router = inject(Router);


  canActivate(): Observable<boolean | UrlTree> {
    return this.authState.isLoggedIn$
      .pipe(
        first(isLoggedIn => !isNull(isLoggedIn)),
        map(isLoggedIn => {
          if (isLoggedIn) {
            return this.router.createUrlTree([ '/' ]);
          }

          return true;
        })
      );
  }

}
